import React from 'react';
import { Eye } from 'lucide-react';

const FillInBlankQuestion = ({ 
  question, 
  result, 
  currentAnswer, 
  submittedFirstTime,
  showExplanation,
  onAnswerChange,
  onToggleExplanation 
}) => {
  const isFirstAttemptCorrect = result?.isCorrect;

  return (
    <div className={`border rounded-lg p-4 transition-colors ${
      !submittedFirstTime ? 'bg-gray-50 border-gray-200 hover:bg-gray-100' :
      isFirstAttemptCorrect ? 'bg-green-50 border-green-200' :
      'bg-red-50 border-red-200'
    }`}>
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="font-medium text-gray-800 leading-relaxed mb-3">
            {question.id}. {question.question}
          </p>
          
          <div className="flex items-center space-x-3">
            <span className="text-sm text-gray-600">Answer:</span>
            <input
              type="text"
              disabled={submittedFirstTime && isFirstAttemptCorrect}
              value={currentAnswer}
              onChange={(e) => onAnswerChange(e.target.value)}
              placeholder="Your answer..."
              className={`px-3 py-2 border-2 rounded-md ${
                submittedFirstTime && isFirstAttemptCorrect
                  ? 'bg-gray-100 border-gray-300 cursor-not-allowed' 
                  : 'bg-white border-blue-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200'
              }`}
            />
          </div>
        </div>
        
        <div className="flex items-center ml-4 space-x-2">
          {submittedFirstTime && (
            <span className={`text-xs px-2 py-1 rounded-full ${
              isFirstAttemptCorrect ? 'bg-green-200 text-green-700' : 'bg-red-200 text-red-700'
            }`}>
              {isFirstAttemptCorrect ? '✓ Correct' : '✗ Incorrect'}
            </span>
          )}
          {submittedFirstTime && (
            <button
              onClick={onToggleExplanation}
              className="text-xs px-2 py-1 rounded-full bg-blue-200 text-blue-700 hover:bg-blue-300 transition-colors flex items-center space-x-1"
            >
              <Eye className="w-3 h-3" />
              <span>Explanation</span>
            </button>
          )}
        </div>
      </div>

      {/* Explanation */}
      {submittedFirstTime && showExplanation && (
        <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <div className="text-sm space-y-2">
            <p><strong>Your answer:</strong> {result?.selected || 'No answer'}</p>
            {isFirstAttemptCorrect && (
              <p><strong>Correct answer:</strong> {question.answer}</p>
            )}
            <div className="pt-2 border-t border-blue-200">
              <p><strong>Explanation:</strong></p>
              <p className="text-gray-700">
                {isFirstAttemptCorrect ? question.feedback?.correct : 
                 (question.feedback?.incorrect || 'The answer is incorrect. Please review the passage and try again.')}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FillInBlankQuestion;